module.exports = __webpack_public_path__ + "static/img/DDMC_H5.9e4fb6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/DDMC_H5.png
// module id = 8wwM
// module chunks = 34